var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424A9F68C57Ee42252925CcOpennessIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_17858)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.6504,
    cy: 14,
    r: 14,
    fill: "#FF7020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 55.0005C38.555 55.0005 49.3003 44.2552 49.3003 31.0002C49.3003 17.7453 38.555 7 25.3 7C12.0451 7 1.2998 17.7453 1.2998 31.0002C1.2998 44.2552 12.0451 55.0005 25.3 55.0005Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3001 55.0005C32.8182 55.0005 38.9128 44.2552 38.9128 31.0002C38.9128 17.7453 32.8182 7 25.3001 7C17.7821 7 11.6875 17.7453 11.6875 31.0002C11.6875 44.2552 17.7821 55.0005 25.3001 55.0005Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 31.3315H49.1505",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_17858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424A9F68C57Ee42252925CcOpennessIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424a9f68c57ee42252925cc_openness-icon-darkstudio-x-webflow-template.71c820df36783ae0582c28a306bb5761.svg";
export { ForwardRef as ReactComponent };